export default "__VITE_ASSET__DfWHjdy$__"